module.exports = __webpack_public_path__ + "img/logo.eedade94.svg";